import React from "react";
import { Badge } from "@/components/ui/badge";
import { ConversationStatus, getStatusConfig } from "@/types/conversation";
import { AlertTriangle, Clock, CheckCircle, Archive, Circle } from "lucide-react";
import { cn } from "@/lib/utils";

interface StatusBadgeProps {
  status: ConversationStatus | null | undefined;
  className?: string;
  showIcon?: boolean;
  size?: "sm" | "md" | "lg";
}

const iconMap = {
  'circle': Circle,
  'alert-triangle': AlertTriangle,
  'clock': Clock,
  'check-circle': CheckCircle,
  'archive': Archive,
};

export function StatusBadge({ 
  status, 
  className, 
  showIcon = true, 
  size = "md" 
}: StatusBadgeProps) {
  const config = getStatusConfig(status);
  
  // Get the icon component
  const IconComponent = config.icon ? iconMap[config.icon as keyof typeof iconMap] : Circle;
  
  // Size variations
  const sizeClasses = {
    sm: "text-xs px-2 py-1",
    md: "text-sm px-2.5 py-1",
    lg: "text-base px-3 py-1.5"
  };
  
  const iconSizes = {
    sm: "h-3 w-3",
    md: "h-3.5 w-3.5", 
    lg: "h-4 w-4"
  };

  return (
    <Badge 
      variant={config.variant}
      className={cn(
        config.className,
        sizeClasses[size],
        "inline-flex items-center gap-1.5 font-medium border",
        className
      )}
    >
      {showIcon && IconComponent && (
        <IconComponent className={iconSizes[size]} />
      )}
      <span>{config.label}</span>
    </Badge>
  );
} 